import locations, { countryMap } from '../constants/locations';

export const formatLocation = (country, key = null) => {
  if (!country) {
    return null;
  }
  const l0 = locations[country];
  let location = null;
  if (!l0) {
    return null;
  }
  // If nothing is passed into the key, we want the country,
  // but if what is passed into the key is undefined,
  // then continue (will like result in an error)
  if (key === null) {
    return countryMap[country];
  }
  // eslint-disable-next-line
  l0.map(l1 => {
    if (l1.value === key) {
      return (location = l1.label);
    }
    // eslint-disable-next-line
    l1.children.map(l2 => {
      if (l2.value === key) {
        return (location = l2.label);
      }
    });
  });
  return location;
};
